import get from 'lodash/get'
import keys from 'lodash/keys'
import size from 'lodash/size'
import { createSelector } from 'reselect'

export const getSelectedStyleColors = (state) =>
  state.removeStyleColorsWithoutQuantities.selectedStyleColors

export const isStyleColorSelected = (state) => (orderId, styleColorId) => {
  const styleColors = get(getSelectedStyleColors(state), orderId, false)

  return styleColors && styleColorId in styleColors
}

export const getCountUnselectedStyleColors = (state) =>
  state.removeStyleColorsWithoutQuantities.countUnselectedStyles

export const getCountStyleColorsSelected = createSelector(
  getSelectedStyleColors,
  (selectedStyleColors) => {
    const orders = keys(selectedStyleColors)
    return orders.reduce(
      (count, order) => count + size(selectedStyleColors[order]),
      0,
    )
  },
)
